import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "startIcon", "endIcon", "disabled", "truncate", "removeUnderline"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ScopedCssBaseline, FocusStyle } from '../StyleBase';
const Root = styled.a.withConfig({
  displayName: "Link__Root",
  componentId: "sc-1qmnm6o-0"
})(["", " ", " color:var(--primary-text);font-weight:var(--text-weight-bold);font-size:inherit;text-decoration-line:none;display:inline-flex;align-items:center;svg{fill:var(--primary-icon);padding-right:", ";padding-left:", ";}", " ", ""], ScopedCssBaseline, FocusStyle, _ref => {
  let {
    $startIcon
  } = _ref;
  return $startIcon ? 'var(--size-spacing-01)' : 0;
}, _ref2 => {
  let {
    $endIcon
  } = _ref2;
  return $endIcon ? 'var(--size-spacing-01)' : 0;
}, _ref3 => {
  let {
    disabled,
    $removeUnderline
  } = _ref3;
  return disabled ? css(["pointer-events:none;color:var(--neutral-text-disabled);svg{fill:var(--neutral-icon-disabled);}"]) : css(["&:hover,&:active,&:focus{text-decoration-line:", ";color:var(--primary-text-hover);svg{fill:var(--primary-icon-hover);}}"], $removeUnderline ? 'none' : 'underline');
}, _ref4 => {
  let {
    $truncate
  } = _ref4;
  return $truncate && css(["flex-wrap:nowrap;white-space:nowrap;overflow:hidden;> span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}> *:not(span){flex:0 0 auto;}"]);
});
const Link = /*#__PURE__*/forwardRef((_ref5, ref) => {
  let {
      children,
      startIcon,
      endIcon,
      disabled,
      truncate,
      removeUnderline
    } = _ref5,
    rest = _objectWithoutPropertiesLoose(_ref5, _excluded);
  return /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref,
    $removeUnderline: removeUnderline,
    $startIcon: !!startIcon,
    $endIcon: !!endIcon,
    $truncate: truncate,
    disabled: disabled,
    "aria-disabled": disabled
  }, rest), startIcon && startIcon, truncate ? /*#__PURE__*/React.createElement("span", null, children) : children, endIcon && endIcon);
});
Link.displayName = 'Link';
Link.style = Root; // Deprecated
Link.Style = Root;
Link.defaultProps = {
  startIcon: null,
  endIcon: null,
  truncate: false,
  disabled: false,
  tabIndex: 0,
  removeUnderline: false
};
process.env.NODE_ENV !== "production" ? Link.propTypes = {
  /**
   * Sets anchor children.
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array, PropTypes.node]).isRequired,
  /**
   * Sets icon to be displayed at the beginning of the line.
   */
  startIcon: PropTypes.node,
  /**
   * Sets icon to be displayed at the end of the line.
   */
  endIcon: PropTypes.node,
  /**
   * Identifies that the text will be truncated when it exceeds the available size.
   */
  truncate: PropTypes.bool,
  /**
   * Sets disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * Sets tabindex.
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Sets if has text underline.
   */
  removeUnderline: PropTypes.bool
} : void 0;
export default Link;